<template>
    <div>
        <label v-if="label" :for="id" v-html="label"></label>
        <div class="input-group">
            <div class="col-3 px-0">
                <input-select
                        name="bdo-day"
                        :select-list-default="daysSelection"
                        v-model="daySelected"
                ></input-select>
            </div>
            <div class="col-6 px-0">
                <input-select
                        name="bdo-month"
                        :select-list-default="monthsSelection"
                        v-model="monthSelected"
                ></input-select>
            </div>
            <div class="col-3 px-0">
                <input-select
                        name="bdo-year"
                        :select-list-default="yearsSelection"
                        v-model="yearSelected"
                ></input-select>
            </div>
            <input type="hidden" :name="name" :value="inputValue">
        </div>
    </div>
</template>

<script>
    import mixinCommon from './mixinCommon';
    import mixinInput from './mixinInput';

    import moment from 'moment';

    import Input from './Input'

    const {props} = Input;

    export default {
        mixins: [mixinCommon, mixinInput],

        components: {
            'input-child': Input,
        },
        props: {
            ...props,
            lang: {
                type: String,
                default: 'en'
            }
        },
        computed: {
            date: {
                get() {
                    return new Date(this.inputValue);
                },
                set(date) {
                    this.inputValue = moment(date).format('YYYY-MM-DD');
                }
            }
        },
        watch: {
            daySelected: function (newData, oldData) {
                if (newData != oldData) {
                    this.updateDate();
                }
            },
            monthSelected: function (newData, oldData) {
                if (newData != oldData) {
                    this.setDaysSelection(newData, this.yearSelected);
                    this.updateDate();
                }
            },
            yearSelected: function (newData, oldData) {
                if (newData != oldData) {
                    this.setDaysSelection(this.monthSelected, newData);
                    this.updateDate();
                }
            },
        },

        data() {
            return {
                daySelected: null,
                daysSelection: [],
                monthSelected: null,
                monthsSelection: [],
                yearSelected: null,
                yearsSelection: [],
            };
        },
        mounted() {
            let datemoment = moment();
            if (this.value) {
                datemoment = moment(this.value);
            }
            this.daySelected = datemoment.format('DD');
            this.monthSelected = datemoment.format('M');
            this.yearSelected = datemoment.format('YYYY');

            this.setDaysSelection(this.monthSelected, this.yearSelected);

            let tmpDate = moment().locale(this.lang).startOf('year');
            for (let i = 1; i <= 12; i++) {
                this.monthsSelection.push({value: tmpDate.format('M'), text: tmpDate.format('MMMM')})
                tmpDate.add(1, 'M');
            }
            for (let i = moment().format('YYYY'); i > 1900; i--) {
                this.yearsSelection.push({value: i, text: i})
            }
        },
        methods: {
            updateDate() {
                let datemoment = moment();
                datemoment.year(this.yearSelected);
                datemoment.month(this.monthSelected - 1);
                datemoment.date(this.daySelected);
                this.inputValue = datemoment.format('YYYY-MM-DD');
            },

            setDaysSelection(month, year) {
                this.daysSelection = [];
                let date = moment().year(year).month(month - 1).startOf('month');
                for (let i = 1; i <= date.daysInMonth(); i++) {
                    this.daysSelection.push({value: date.format('DD'), text: date.format('DD')});
                    date.add(1, 'd');
                }
            }

        }
    };
</script>
